import { FC, ReactNode, useEffect, useRef } from 'react';
import { useTimeout } from 'Context/TimeoutContext';
import styles from './TableActionTopbar.module.scss';

function useOutsideAlerter(ref: any, callback: () => void) {
  const { set, clear } = useTimeout();

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        clear('DropdownActionTopbar-handleClickOutside');
        set('DropdownActionTopbar-handleClickOutside', () => {
          callback();
        }, 200);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      clear('DropdownActionTopbar-handleClickOutside');
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, ref, set, clear]);
}

export interface IDropdown {
  dropdownContent: ReactNode;
  toggleDropdown: () => void;
}

const DropdownActionTopbar: FC<IDropdown> = ({
  dropdownContent,
  toggleDropdown,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  useOutsideAlerter(wrapperRef, toggleDropdown);

  return (
    <div ref={wrapperRef} className={styles['dropdownMenu']}>
      {typeof dropdownContent === 'function'
        ? dropdownContent(toggleDropdown)
        : dropdownContent
      }
    </div>
  );
};

export default DropdownActionTopbar;
